import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: '/preview',
    component: LAYOUT,
    redirect: '/preview/events',
    meta: { title: '活动预告', hide: true, showNavPanel: true },
    children: [
      {
        path: 'events',
        name: '活动预告',
        component: () => import('@/views/preview/events.vue'),
        meta: { title: '活动预告', hide: true, showNavPanelBorder: true },
      },
    ],
  },
]
